<template>
  <div>
    <div class="algo-form">
      <div class="modal-body">
        <base-select
          v-if="selectedAppGroupOptions.length > 0"
          v-model="formItems.applicationId"
          @change="changeSelectedApp"
          id="application"
          :options="selectedAppGroupOptions"
          fieldLabel="Uygulama"
          placeholder="Uygulama Seç"
          :selected-id="formItems.applicationId"
          :error="!isTradingView && $v.formItems.applicationId.$error"
        />
        <base-input
          v-model="formItems.name"
          inputType="text"
          labelText="Adı"
          @input="$v.formItems.name.$touch()"
          :class="{ 'is-invalid': $v.formItems.name.$error }"
        />
        <div v-if="$v.formItems.name.$error">
          <p class="invalid-feedback" v-if="$v.formItems.name.$invalid">
            {{ invalidMessage }}
          </p>
        </div>
        <base-input
          v-model="formItems.order"
          inputType="hidden"
          labelText="Sıra No"
          value="formItems.order"
        />
        <base-input
          v-model="formItems.shortContent"
          inputType="text"
          labelText="Kısa Tanım"
        />
        <base-input
          v-model="formItems.description"
          inputType="text"
          labelText="Açıklama"
        />
        <base-select
          v-model="selectedMandatoryGroupVal"
          @change="changeIsAgreementMandatoryGroup"
          id="isAgreementMandatory"
          :options="booleanOptions"
          fieldLabel="Sözleşme Kontrolü gerekli mi?"
          placeholder="isAgreementMandatory Seç"
          :selected-id="selectedMandatoryGroupVal.code"
        />
        <base-select
          v-model="selectedLevelGroupVal"
          :value="selectedLevelGroupVal"
          @change="changeIsHighLevelGroup"
          id="isHighLevel"
          :options="booleanOptions"
          fieldLabel="Alınabilecek en yüksek paket mi?"
          placeholder="isHighLevel Seç"
          :selected-id="selectedLevelGroupVal.code"
        />
        <base-select
          v-model="selectedPurchasableGroupVal"
          :value="selectedPurchasableGroupVal"
          @change="changeIsExternalPurchasableGroup"
          id="isExternalPurchasable"
          :options="booleanOptions"
          fieldLabel="Harici Terminal ile alınabilir mi?"
          placeholder="isExternalPurchasable Seç"
          :selected-id="selectedPurchasableGroupVal.code"
        />
        <base-select
          v-model="selectedIsConnectedToMainProduct"
          :value="selectedIsConnectedToMainProduct"
          @change="changeIsConnectedMainProduct"
          id="isConnectedMainProduct"
          :options="booleanOptions"
          fieldLabel="Ana Ürüne Bağlanacak mı?"
          placeholder="Ana Ürüne Bağlanacak mı?"
          :selected-id="selectedIsConnectedToMainProduct.code"
        />
        <base-input
          v-model="formItems.price"
          @input="$v.formItems.price.$touch()"
          inputType="number"
          labelText="Fiyat"
          id="algoPrice"
          value="formItems.price"
          :allowDecimals="true"
          @change="calculate(formItems.price)"
          :class="{ 'is-invalid': $v.formItems.price.$error }"
        />
        <div v-if="$v.formItems.price.$error">
          <p class="invalid-feedback" v-if="$v.formItems.price.$invalid">
            {{ invalidMessage }}
          </p>
        </div>
        <base-input
          v-model="formItems.priceCostMultiplier"
          @input="$v.formItems.priceCostMultiplier.$touch()"
          inputType="number"
          labelText="Fiyat Maliyet Çarpanı"
          :isDisabled="true"
          id="algoPriceCostMultiplier"
          :class="{
            'is-invalid': $v.formItems.priceCostMultiplier.$error,
          }"
        />
        <div v-if="$v.formItems.priceCostMultiplier.$error">
          <p
            class="invalid-feedback"
            v-if="$v.formItems.priceCostMultiplier.$invalid"
          >
            {{ invalidMessage }}
          </p>
        </div>
        <base-input
          v-model="formItems.screenPrice"
          @input="$v.formItems.screenPrice.$touch()"
          inputType="number"
          labelText="Ekran Ücreti"
          id="algoScreenPrice"
          :class="{
            'is-invalid': $v.formItems.screenPrice.$error,
          }"
        />
        <div v-if="$v.formItems.screenPrice.$error">
          <p class="invalid-feedback" v-if="$v.formItems.screenPrice.$invalid">
            {{ invalidMessage }}
          </p>
        </div>
        <base-input
          v-model="formItems.cost"
          @input="$v.formItems.cost.$touch()"
          inputType="number"
          labelText="Maliyet"
          id="algoCost"
          :class="{
            'is-invalid': $v.formItems.cost.$error,
          }"
        />
        <div v-if="$v.formItems.cost.$error">
          <p class="invalid-feedback" v-if="$v.formItems.cost.$invalid">
            {{ invalidMessage }}
          </p>
        </div>
        <base-input
          v-model="formItems.fundAmount"
          @input="$v.formItems.fundAmount.$touch()"
          inputType="number"
          labelText="Fon Miktarı"
          :isDisabled="true"
          id="algoFundAmount"
          :class="{
            'is-invalid': $v.formItems.fundAmount.$error,
          }"
        />
        <div v-if="$v.formItems.fundAmount.$error">
          <p class="invalid-feedback" v-if="$v.formItems.fundAmount.$invalid">
            {{ invalidMessage }}
          </p>
        </div>
        <base-input
          v-model="formItems.commissionAmount"
          @input="$v.formItems.commissionAmount.$touch()"
          inputType="number"
          labelText="Komisyon Miktarı"
          :isDisabled="true"
          id="algoCommissionAmount"
          :class="{
            'is-invalid': $v.formItems.commissionAmount.$error,
          }"
        />
        <div
          v-if="!$v.formItems.commissionAmount.required"
          class="invalid-feedback"
        ></div>
        <div
          v-for="(item, index) in additionalWarnings"
          :key="index"
          class="grouped-container with-button"
        >
          <base-input
            v-model="additionalWarnings[index]"
            inputType="text"
            labelText="Uyarılar"
            id="algoVdProducrtWarnings"
          />
          <div
            v-if="index === 0"
            @click.prevent="addRemoveAdditionalWarnings()"
            class="add-button"
          >
            <base-icon :name="'plus-circle'" />
          </div>
          <div
            v-else
            @click.prevent="addRemoveAdditionalWarnings(index)"
            class="add-button remove"
          >
            <base-icon :name="'close-colored'" />
          </div>
        </div>
        <br />
        <photo-upload :base64Img="setPhotoForForm" />
      </div>
      <div class="modal-bottom">
        <base-button class="giveUp" @click="$modal.hide('modal')"
          >Vazgeç</base-button
        >
        <base-button
          @click="sendForm"
          class="add"
          :disabled="isTradingView ? false : $v.$invalid"
          :class="{ disabled: isTradingView ? false : $v.$invalid }"
          >Kaydet</base-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { BaseSelect, BaseInput, BaseButton, BaseIcon } from "@/components";
import { required, minValue } from "vuelidate/lib/validators";
import PhotoUpload from "@/components/productAndPackage/PhotoUpload";
import mixins from "../../mixins/index";

export default {
  name: "AlgoDefinitionForm",
  mixins: [mixins],
  props: {
    clickedNewItemBtn: Boolean,
    applicationId: Number,
    selectedDataApplicationId: Number,
    id: Number,
    selectedDataId: Number,
    name: String,
    selectedDataName: String,
    order: Number,
    selectedDataOrder: Number,
    isAgreementMandatory: Boolean,
    isHighLevel: Boolean,
    isExternalPurchasable: Boolean,
    isConnectMainProduct: Boolean,
    price: Number,
    priceCostMultiplier: Number,
    screenPrice: Number,
    cost: Number,
    priceType: Number,
    fundAmount: Number,
    commissionAmount: Number,
    vdProducrtWarnings: Array,
    selectedDataPrice: Number,
    selectedDataPriceCostMultiplier: Number,
    selectedDataScreenPrice: Number,
    selectedDataCost: Number,
    selectedDataFundAmount: Number,
    selectedDataCommissionAmount: Number,
    selectedDataVdProducrtWarnings: Array,
    additionalWarnings: Array,
    selectedShortContent: String,
    selectedDescription: String,
    shortContent: String,
    description: String,
    selectedDataApplication: Object,
    filterAttribute: Array,
  },
  data() {
    return {
      selectedDataAppVal: "",
      clickedNewBtn: this.clickedNewItemBtn,
      selectedMandatoryGroupVal: {
        label: "Evet",
        value: true,
        code: 1,
      },
      selectedLevelGroupVal: {
        label: "Evet",
        value: true,
        code: 1,
      },
      selectedPurchasableGroupVal: {
        label: "Evet",
        value: true,
        code: 1,
      },
      selectedIsConnectedToMainProduct: {
        label: "Evet",
        value: true,
        code: 1,
      },
      invalidMessage: "Bu alan boş bırakılamaz!",
      booleanOptions: [
        {
          label: "Evet",
          value: true,
          code: 1,
        },
        {
          label: "Hayır",
          value: false,
          code: 2,
        },
      ],
      selectedAppGroupOptions: [],
      submitted: false,
      formItems: {
        application: this.selectedDataApplication,
        applicationId: this.selectedDataApplicationId,
        id: this.selectedDataId,
        name: this.selectedDataName,
        order: this.selectedDataOrder,
        shortContent: this.selectedShortContent,
        description: this.selectedDescription,
        isAgreementMandatory: this.isAgreementMandatory,
        isHighLevel: this.isHighLevel,
        isExternalPurchasable: this.isExternalPurchasable,
        isConnectMainProduct: this.isConnectMainProduct,
        price: this.selectedDataPrice,
        priceCostMultiplier: this.selectedDataPriceCostMultiplier,
        screenPrice: this.selectedDataScreenPrice,
        cost: this.selectedDataCost,
        fundAmount: this.selectedDataFundAmount,
        commissionAmount: this.selectedDataCommissionAmount,
        vdProducrtWarnings: this.additionalWarnings,
        year: null,
        month: null,
      },
    };
  },
  methods: {
    getFilter() {
      this.selectedAppGroupOptions = this.getFilterList.filter(
        (o) => o.name === "Applications"
      )[0].values;

      const firstItem = this.selectedAppGroupOptions.filter(
        (x) => x.code === 0
      );
      if (firstItem.length === 0) {
        this.selectedAppGroupOptions.unshift({
          code: 0,
          label: "Uygulam Seçiniz",
        });
      }

      if (this.clickedNewItemBtn) {
        this.formItems.applicationId = 0;
        this.formItems.application = this.selectedAppGroupOptions[0].label;
      }
    },
    calculate(price) {
      this.formItems.commissionAmount = Math.round(
        Number(price) * Number(this.formItems.priceCostMultiplier)
      );
      let calculatedFundAmount =
        (Number(this.formItems.commissionAmount) / 0.7) * 1200;

      this.formItems.fundAmount = this.integersToRound(
        calculatedFundAmount,
        String(this.formItems.commissionAmount).length
      );
    },
    addRemoveAdditionalWarnings(index = null) {
      if (index === null) {
        this.additionalWarnings.push("");
      } else {
        this.additionalWarnings.splice(index, 1);
      }
    },
    changeIsAgreementMandatoryGroup(value) {
      this.formItems.isAgreementMandatory = value.value;
    },
    changeIsHighLevelGroup(value) {
      this.formItems.isHighLevel = value.value;
    },
    changeIsExternalPurchasableGroup(value) {
      this.formItems.isExternalPurchasable = value.value;
    },
    changeIsConnectedMainProduct(value) {
      this.formItems.isConnectMainProduct = value.value;
    },
    changeSelectedApp(value) {
      this.formItems.applicationId = value.code;
      this.formItems.application = value.label;
    },
    sendForm() {
      this.submitted = true;
      this.$v.$touch();

      const isInvalid = this.isTradingView
        ? this.$v.formItems.$invalid
        : this.$v.$invalid;

      if (isInvalid) return;


      this.formItems.id = Number(this.formItems.id);
      if (this.isTradingView) {
        this.formItems.applicationId = null;
        this.formItems.application = null;
      } else {
        this.formItems.applicationId =
          Number(this.formItems.applicationId) === 0
            ? this.selectedAppGroupOptions[0].code
            : Number(this.formItems.applicationId);
      }
      console.log("applicationId", this.formItems.applicationId);
      this.formItems.order = Number(this.formItems.order);
      this.formItems.price = Number(this.formItems.price);
      this.formItems.priceCostMultiplier = Number(
        this.formItems.priceCostMultiplier
      );
      this.formItems.screenPrice = Number(this.formItems.screenPrice);
      this.formItems.cost = Number(this.formItems.cost);
      this.formItems.fundAmount = Number(this.formItems.fundAmount);
      this.formItems.commissionAmount = Number(this.formItems.commissionAmount);

      if (
        this.formItems.vdProducrtWarnings.length === 1 &&
        this.formItems.vdProducrtWarnings[0] === ""
      ) {
        this.formItems.vdProducrtWarnings = [];
      }
      if (this.clickedNewItemBtn) {
        delete this.formItems.id;
        delete this.formItems.order;
      }
      this.formItems.year = this.getAlgoManagementFilter.year;
      this.formItems.month = this.getAlgoManagementFilter.month;

      this.$emit("submit-form", this.formItems);
    },
    setPhotoForForm(base64) {
      this.formItems.imageFileBase64 = base64;
    },
  },
  components: {
    BaseSelect,
    BaseInput,
    BaseButton,
    BaseIcon,
    PhotoUpload,
  },
  computed: {
    ...mapGetters(["getFilterList", "getProductManagementAlgoFilter"]),
    getAlgoManagementFilter() {
      return this.getProductManagementAlgoFilter;
    },
    isTradingView() {
      const n = (this.formItems.name).toString().trim().toLowerCase();
      return n === "trading view";
    },
  },
  mounted() {
    this.getFilter();

    this.selectedMandatoryGroupVal = this.booleanOptions.find(
      (x) => x.value === this.isAgreementMandatory
    );
    this.selectedLevelGroupVal = this.booleanOptions.find(
      (x) => x.value === this.isHighLevel
    );
    this.selectedPurchasableGroupVal = this.booleanOptions.find(
      (x) => x.value === this.isExternalPurchasable
    );
    this.selectedIsConnectedToMainProduct = this.booleanOptions.find(
      (x) => x.value === this.isConnectMainProduct
    );
  },
  watch: {
    priceCostMultiplier(val) {
      const priceMultiplier = Number(val);
      this.priceMultiplier = priceMultiplier;
      this.formItems.priceCostMultiplier = priceMultiplier;
    },
    getAlgoManagementFilter: {
      handler: function (newVal) {
        this.formItems.year = newVal.year;
        this.formItems.month = newVal.month;
      },
    },
  },
  validations() {
    return {
      formItems: {
        applicationId: this.isTradingView
          ? {}
          : { required, minValue: minValue(1) },
        name: { required },
        price: { required },
        priceCostMultiplier: { required },
        screenPrice: { required },
        cost: { required },
        fundAmount: { required },
        commissionAmount: { required },
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.product-managements-container {
  .modal-body {
    .grouped-container {
      position: relative;
      &.with-button {
        width: 100%;
        .add-button {
          position: absolute;
          right: -14px;
          top: calc(50% - 10px);
          width: 35px;
          height: 35px;
          padding: 6px;
          border-radius: 4px;
          background-color: #242424;
          box-sizing: border-box;
          cursor: pointer;
          color: white;
          &.remove {
            background-color: #dc3545;
            color: white;
          }
        }
      }
      .title {
        position: absolute;
        top: -9px;
        left: 30px;
        font-weight: bold;
        font-size: 14px;
        color: #242424;
        background-color: white;
        padding: 0 8px;
      }
    }
    .form-group {
      width: 93%;
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss">
.invalid-feedback {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  padding-left: 10px;
}
.is-invalid {
  input {
    border: 1px solid red !important;
  }
}
</style>
